import React from 'react';
import { toast } from 'react-toastify';

import { Auth0Context, useAuth0 } from '../components/Auth0Provider';
import { auth0Audience } from '../api/API';

type Args = {
  /** scope e.g. 'admin:students' */
  scope: string | undefined;
};

/** Hook to get auth0 token */
export const useToken = (args?: Args) => {
  const [isGettingToken, setIsGettingToken] = React.useState(false);
  const [token, setToken] = React.useState<string | undefined>(undefined);

  const { isAuthenticated, getTokenSilently } = useAuth0() as Auth0Context;

  React.useEffect(() => {
    if (isAuthenticated) {
      (async () => {
        try {
          setIsGettingToken(true);
          const token = await getTokenSilently({ audience: auth0Audience, scope: args?.scope });
          setToken(token);
          setIsGettingToken(false);
        } catch (e) {
          toast.error(e.message + ' (while getting token)');
          setIsGettingToken(false);
        }
      })();
    }
  }, [isAuthenticated]);

  return { token, isGettingToken };
};
